import React from 'react';

export function Footer(){
    return (
        <div className="w-full absolute bottom-0 text-2xl text-center border-t py-10 align-middle ...">
            Made with ❤️
        </div>
    );
}